/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/

export default {
    your_name             : 'Adınız',
    your_email            : 'E-posta adresiniz',
    company_name          : 'Firma Adı',
    message               : 'İleti',
    mobile                : 'Telefon',
    your_file             : 'Dosyanız',
    name                  : 'İsim',
    email                 : 'e-posta',
    attachment            : 'CV\'yi yükle',
    country_selector_label: 'Ülke kodu',
    country_selector_error: 'Ülke Seçiniz',
    phone_number_label    : 'Telefon numarası',
    example               : 'Örnek:',
    message_title         : 'Mesaj Konusu',

};
